export default __webpack_public_path__ + "assets/images/7ebb40fbe34d026497bb23a4173acb31.svg";